import { LazyLoadMoreModel } from '@_types/types';
import { currentViewport } from '@helpers/breakpoint';

const getLazyLoadMorePageSize = (element: HTMLElement) => {
  switch (currentViewport()) {
    case 'desktop':
      return element.dataset.pageSizeDesktop;
    case 'tablet':
      return element.dataset.pageSizeTablet;
    default:
      return element.dataset.pageSizeMobile;
  }
};

const researchSearchLazyLoadMore: LazyLoadMoreModel = {
  offset: 0,
  currentPage: 1,
  excludeJs: true,
  loadMoreButton: {
    text: 'Load more',
    type: 'button',
    dataSet: {
      'data-theme': 'black',
    },
    styleModifier: ['secondary', 'small'],
  },
  lazyLoadMoreSourceId: 'research-search-load-more',
  sourceEndpoint: '/api/research/search',
  searchId: 'research-search',
};

const searchLazyLoadMore: LazyLoadMoreModel = {
  ...researchSearchLazyLoadMore,
  loadMoreButton: {
    ...researchSearchLazyLoadMore.loadMoreButton,
    dataSet: {},
    styleModifier: ['primary', 'small'],
  },
};

export { researchSearchLazyLoadMore, getLazyLoadMorePageSize, searchLazyLoadMore };
